<template>
  <div class="mt-4">
    <ProfessorProgressionReportTable
      :campuses_="campuses_"
      :egress_profiles_="egress_profiles_"
      :levels_="levels_"
      :matters_="matters_"
      :periods_="periods_"
      :sections_="sections_"
      :professors_="professors_"
      :is_active_section_="is_active_section_"
      :selected_is_active_section="selected_is_active_section"
    >
    </ProfessorProgressionReportTable>
  </div>
</template>

<script>
// import * as names from "@/store/names";
// import { mapGetters } from "vuex";
export default {
  name: "ProfessorProgressionReport",
  components: {
    ProfessorProgressionReportTable: () =>
      import(
        "@/components/reports/TeachingReport/ProfessorProgressionReport/ProfessorProgressionReportTable"
      ),
  },
  props: {
    campuses_: {
      type: Array,
    },
    egress_profiles_: {
      type: Array,
    },
    levels_: {
      type: Array,
    },
    matters_: {
      type: Array,
    },
    periods_: {
      type: Array,
    },
    sections_: {
      type: Array,
    },
    professors_: {
      type: Array,
    },
    is_active_section_: {
      type: Array,
    },
  },
  data() {
    return {
      // is_active_section: [
      //   { id: 1, name: "Secciones Actuales" },
      //   { id: 2, name: "Secciones Pasadas" },
      // ],
    };
  },
  computed: {
    // ...mapGetters({}),
    selected_is_active_section() {
      const is_active_section_ids = this.is_active_section_.map((x) => x.id);
      if (
        is_active_section_ids.includes(1) &&
        is_active_section_ids.includes(2)
      )
        return 3;
      else if (is_active_section_ids.includes(1)) return 1;
      else if (is_active_section_ids.includes(2)) return 2;
      else return 3;
    },
  },
  methods: {},
  created() {},
};
</script>

<style scoped>
</style>

